var _g, _rect, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOutlookInvisible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7240_24377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.0002 26.9771C47.0027 26.649 46.8329 26.343 46.5532 26.1716H46.5483L46.531 26.1617L31.977 17.5468C31.9139 17.5041 31.8491 17.4656 31.7818 17.4303C31.2199 17.1407 30.5522 17.1407 29.9902 17.4303C29.923 17.4656 29.8574 17.5041 29.795 17.5468L15.241 26.1609L15.2238 26.1707C14.7792 26.4472 14.643 27.0321 14.9195 27.4767C15.0007 27.6079 15.1131 27.717 15.2468 27.795L29.7999 36.4099C29.8631 36.4517 29.9279 36.4911 29.9952 36.5264C30.5571 36.8159 31.2248 36.8159 31.7867 36.5264C31.854 36.4911 31.9188 36.4525 31.982 36.4099L46.5351 27.795C46.8263 27.626 47.0035 27.3134 47.0002 26.9771Z",
    fill: "#0A2767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9386 21.225H26.4895V29.9793H16.9386V21.225ZM45.0474 12.3254V8.32063C45.0704 7.31903 44.2779 6.48888 43.2763 6.46509H18.4922C17.4906 6.48888 16.6982 7.31985 16.7212 8.32063V12.3254L31.372 16.2325L45.0474 12.3254Z",
    fill: "#0364B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7207 12.3254H26.4882V21.1159H16.7207V12.3254Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2557 12.3254H26.4883V21.1159L36.2557 29.9064H45.0462V21.1167L36.2557 12.3254Z",
    fill: "#28A8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4883 21.1167H36.2557V29.9072H26.4883V21.1167Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4883 29.9072H36.2557V38.6977H26.4883V29.9072Z",
    fill: "#0364B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9375 29.9792H26.4884V37.9379H16.9375V29.9792Z",
    fill: "#14447D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2559 29.9072H45.0463V38.6977H36.2559V29.9072Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5532 27.7414L46.5343 27.7513L31.9812 35.9363C31.918 35.9757 31.8532 36.0126 31.7859 36.0454C31.539 36.1628 31.27 36.23 30.9968 36.2407L30.2019 35.7756C30.1347 35.7419 30.0698 35.7042 30.0067 35.6632L15.2575 27.246H15.2509L14.7686 26.9761V43.5464C14.7759 44.6522 15.6783 45.5422 16.7832 45.5348H45.0168C45.0332 45.5348 45.0479 45.5266 45.066 45.5266C45.2998 45.5119 45.5295 45.4635 45.7493 45.3839C45.8445 45.3437 45.9363 45.2961 46.0241 45.2412C46.0897 45.2042 46.2021 45.123 46.2021 45.123C46.7025 44.7531 46.9986 44.1682 47.0011 43.5456V26.9769C47.0003 27.2935 46.8288 27.5856 46.5532 27.7414Z",
    fill: "url(#paint0_linear_7240_24377)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M46.2178 26.9113V27.9268L31.0002 38.4047L15.2453 27.2534C15.2453 27.2476 15.2412 27.2435 15.2354 27.2435L13.79 26.374V25.6414L14.3856 25.6316L15.6456 26.3543L15.6751 26.3641L15.7826 26.4322C15.7826 26.4322 30.59 34.8814 30.6294 34.9003L31.1963 35.2325C31.2455 35.2128 31.2939 35.1932 31.3529 35.1743C31.3825 35.1546 46.0529 26.9014 46.0529 26.9014L46.2178 26.9113Z",
    fill: "#0A2767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5532 27.7416L46.5343 27.7522L31.9812 35.9373C31.918 35.9767 31.8532 36.0136 31.7859 36.0464C31.2207 36.3229 30.5596 36.3229 29.9944 36.0464C29.9271 36.0136 29.8623 35.9767 29.7991 35.9373L15.246 27.7522L15.2288 27.7416C14.9474 27.589 14.7718 27.2962 14.7686 26.9771V43.5465C14.7759 44.6515 15.6775 45.5424 16.7824 45.535H44.9872C46.0922 45.5424 46.9945 44.6515 47.0011 43.5465V26.9771C47.0003 27.2937 46.8288 27.5857 46.5532 27.7416Z",
    fill: "#1490DF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M32.193 35.8167L31.9748 35.9389C31.9116 35.9791 31.8468 36.016 31.7795 36.0496C31.5392 36.1677 31.2783 36.2366 31.0117 36.2531L36.5488 42.8008L46.208 45.128C46.473 44.9279 46.683 44.6654 46.8208 44.3635L32.193 35.8167Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M33.179 35.2612L31.9748 35.938C31.9116 35.9782 31.8468 36.0151 31.7795 36.0487C31.5392 36.1669 31.2783 36.2358 31.0117 36.2522L33.6055 43.4045L46.2105 45.1247C46.7068 44.7522 46.9996 44.1674 46.9996 43.5464V43.3323L33.179 35.2612Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8093 45.535H44.9838C45.4177 45.5374 45.8402 45.4004 46.1896 45.1445L30.2001 35.7782C30.1329 35.7446 30.068 35.7068 30.0049 35.6658L15.2557 27.2486H15.2491L14.7676 26.9771V43.4899C14.7668 44.6179 15.6806 45.5342 16.8093 45.535Z",
    fill: "#28A8EA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M28.4422 16.0692V36.9035C28.4405 37.6336 27.9959 38.2907 27.3192 38.5638C27.1092 38.6541 26.8836 38.7008 26.6547 38.7008H14.7676V15.2563H16.7207V14.2793H26.6539C27.6416 14.2826 28.4397 15.0824 28.4422 16.0692Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M27.4652 17.0462V37.8805C27.4677 38.1167 27.4176 38.3497 27.3184 38.5638C27.0468 39.2323 26.3988 39.6712 25.6777 39.6745H14.7676V15.2554H25.6777C25.9607 15.253 26.2405 15.3235 26.4882 15.4605C27.087 15.7624 27.4652 16.376 27.4652 17.0462Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M27.4652 17.0462V35.9265C27.4603 36.9125 26.6637 37.7123 25.6777 37.7205H14.7676V15.2554H25.6777C25.9607 15.253 26.2405 15.3235 26.4882 15.4605C27.087 15.7624 27.4652 16.376 27.4652 17.0462Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M26.4882 17.0464V35.9267C26.4874 36.9143 25.6884 37.7158 24.7007 37.7207H14.7676V15.2556H24.7007C25.6884 15.2564 26.489 16.0571 26.4882 17.0447C26.4882 17.0455 26.4882 17.0455 26.4882 17.0464Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.79074 15.2556H24.6982C25.6866 15.2556 26.4889 16.0571 26.4889 17.0464V34.9538C26.4889 35.9423 25.6875 36.7445 24.6982 36.7445H6.79074C5.80145 36.7445 5 35.9423 5 34.9538V17.0464C5 16.0579 5.80145 15.2556 6.79074 15.2556Z",
    fill: "url(#paint1_linear_7240_24377)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5962 22.7648C11.0375 21.8247 11.7495 21.038 12.6412 20.5056C13.6289 19.9404 14.7535 19.6582 15.8905 19.691C16.9446 19.6681 17.9847 19.9355 18.8977 20.4638C19.7558 20.9757 20.4473 21.7254 20.887 22.622C21.3669 23.6105 21.6056 24.6982 21.5843 25.7966C21.6072 26.9442 21.3619 28.082 20.8665 29.1173C20.4161 30.0467 19.7025 30.8227 18.8157 31.351C17.8674 31.8957 16.7887 32.1696 15.6961 32.1442C14.619 32.1705 13.5559 31.8998 12.6223 31.3625C11.7569 30.8498 11.0572 30.0992 10.606 29.2001C10.1237 28.2264 9.88168 27.1501 9.90054 26.0641C9.88086 24.9263 10.1187 23.7983 10.5962 22.7648ZM12.7757 28.0689C13.0112 28.6636 13.4098 29.1788 13.9266 29.5553C14.4525 29.9228 15.0825 30.1123 15.7239 30.0967C16.4073 30.1238 17.0807 29.9277 17.6427 29.5381C18.1529 29.1624 18.5409 28.6456 18.7599 28.0517C19.0052 27.388 19.1258 26.685 19.1168 25.9779C19.1241 25.2642 19.0109 24.5539 18.7804 23.8779C18.577 23.2676 18.2013 22.7295 17.6984 22.3292C17.1505 21.9215 16.4794 21.7139 15.7969 21.7435C15.1415 21.7262 14.4976 21.9174 13.9578 22.2898C13.4328 22.668 13.0259 23.188 12.7856 23.7893C12.2524 25.1666 12.2491 26.6932 12.7774 28.0722L12.7757 28.0689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2559 12.3254H45.0463V21.1159H36.2559V12.3254Z",
    fill: "#50D9FF"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 29,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7240_24377)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    transform: "translate(34 33.5811)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4647 44.0462C43.4675 44.8063 42.2533 45.2274 40.9997 45.2479C36.9163 45.2479 34.583 40.5812 34.583 40.5812C35.3086 39.229 36.315 38.0476 37.5347 37.1162M39.7747 36.0546C40.1762 35.9606 40.5873 35.9136 40.9997 35.9146C45.083 35.9146 47.4163 40.5812 47.4163 40.5812C47.0622 41.2437 46.64 41.8673 46.1563 42.4421M42.2363 41.8179C42.0761 41.9898 41.8829 42.1277 41.6683 42.2234C41.4536 42.319 41.2219 42.3705 40.9869 42.3746C40.7519 42.3788 40.5185 42.3355 40.3006 42.2475C40.0827 42.1595 39.8848 42.0285 39.7186 41.8623C39.5524 41.6961 39.4214 41.4982 39.3334 41.2803C39.2454 41.0624 39.2021 40.829 39.2063 40.594C39.2104 40.359 39.2619 40.1273 39.3575 39.9126C39.4532 39.698 39.5911 39.5048 39.763 39.3446",
    fill: "#D8DCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4647 44.0462C43.4675 44.8063 42.2533 45.2274 40.9997 45.2479C36.9163 45.2479 34.583 40.5812 34.583 40.5812C35.3086 39.229 36.315 38.0476 37.5347 37.1162M39.7747 36.0546C40.1762 35.9606 40.5873 35.9136 40.9997 35.9146C45.083 35.9146 47.4163 40.5812 47.4163 40.5812C47.0622 41.2437 46.64 41.8673 46.1563 42.4421M42.2363 41.8179C42.0761 41.9898 41.8829 42.1277 41.6683 42.2234C41.4536 42.319 41.2219 42.3705 40.9869 42.3746C40.7519 42.3788 40.5185 42.3355 40.3006 42.2475C40.0827 42.1595 39.8848 42.0285 39.7186 41.8623C39.5524 41.6961 39.4214 41.4982 39.3334 41.2803C39.2454 41.0624 39.2021 40.829 39.2063 40.594C39.2104 40.359 39.2619 40.1273 39.3575 39.9126C39.4532 39.698 39.5911 39.5048 39.763 39.3446",
    stroke: "#2084FA",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.583 34.1646L47.4163 46.9979",
    stroke: "#711DDC",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7240_24377",
    x1: 30.884,
    y1: 26.9767,
    x2: 30.884,
    y2: 45.5348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35B8F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28A8EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7240_24377",
    x1: 8.73296,
    y1: 13.8569,
    x2: 22.7554,
    y2: 38.1432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1784D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#107AD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A63C9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7240_24377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(5 5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7240_24377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(34 33.5811)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOutlookInvisible);
export default __webpack_public_path__ + "static/media/icon_outlook_invisible.72ef8de9b36e55a32a15fe7d84f11aec.svg";
export { ForwardRef as ReactComponent };